(function () {
  if (window.dppCollectionVariantPickerReady) return
  window.dppCollectionVariantPickerReady = true

  document.addEventListener('click', async function (event) {
    var choice = event.target.closest('[data-variant-choice]')
    if (!choice || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return
    var card = choice.closest('[data-variant-card]')
    if (!card) return
    event.preventDefault()
    if (card.getAttribute('aria-busy') === 'true' || card.dataset.selectedVariant === choice.dataset.variantChoice) return

    var url = new URL(choice.href, window.location.href)
    if (url.origin !== window.location.origin) return
    url.searchParams.set('section_id', 'collection-variant-card')
    var purchase = card.querySelector('.collection-product-row__purchase')
    var status = card.querySelector('[data-variant-status]')
    var controller = new AbortController()
    var timeout = window.setTimeout(function () { controller.abort() }, 10000)
    var focusedChoice = document.activeElement === choice
    card.setAttribute('aria-busy', 'true')
    if (purchase) purchase.inert = true
    if (status) {
      status.textContent = ''
      status.className = 'sr-only'
    }

    try {
      var response = await fetch(url.toString(), { signal: controller.signal, credentials: 'same-origin' })
      if (!response.ok) throw new Error('variant_request_failed')
      var html = new DOMParser().parseFromString(await response.text(), 'text/html')
      var replacement = html.querySelector('[data-variant-card]')
      if (!replacement || replacement.dataset.productId !== card.dataset.productId || replacement.dataset.selectedVariant !== choice.dataset.variantChoice) {
        throw new Error('variant_response_mismatch')
      }
      if (!card.isConnected) return
      card.replaceWith(replacement)
      var selectedChoice = replacement.querySelector('[aria-current="true"][data-variant-choice]')
      var replacementStatus = replacement.querySelector('[data-variant-status]')
      if (replacementStatus && selectedChoice) replacementStatus.textContent = selectedChoice.textContent.trim()
      if (focusedChoice && selectedChoice) selectedChoice.focus({ preventScroll: true })
      document.dispatchEvent(new CustomEvent('dpp:collection-variant-changed', { detail: { card: replacement } }))
    } catch (error) {
      if (status && card.isConnected) {
        status.className = 'mt-2 text-sm text-dpp-muted'
        status.textContent = status.dataset.errorMessage
      }
    } finally {
      window.clearTimeout(timeout)
      card.removeAttribute('aria-busy')
      if (purchase) purchase.inert = false
    }
  })

  document.addEventListener('submit', function (event) {
    var card = event.target.closest('[data-variant-card]')
    if (card && card.getAttribute('aria-busy') === 'true') {
      event.preventDefault()
      event.stopImmediatePropagation()
    }
  }, true)
})()
